import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PermissionSet } from './permission-set';
import { PermissionSetsStore } from './store';

export const permissionSetsSlice = createSlice({
  name: '@@PERMISSION_SETS',
  initialState: PermissionSetsStore.empty(),

  reducers: (create) => ({
    putAll: create.reducer(
      (
        state: PermissionSetsStore,
        { payload: sets }: PayloadAction<PermissionSet[]>,
      ) => PermissionSetsStore.putAll(sets)(state),
    ),
  }),
});
